import AjaxService, { validateResponse } from 'services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const createCRUD = baseUrl => ({
    fetch: ({ offset, limit }) => {
        return AjaxService({
            method: 'get',
            url: baseUrl,
            params: {
                offset,
                limit
            }
        })
        .then(response => response.data)
        .catch(handleServerError);
    },

    fetchSingle: resourceId => {
        return AjaxService({
            method: 'get',
            url: `${baseUrl}/${resourceId}`
        })
        .then(response => validateResponse(response, 'id').data)
        .catch(handleServerError);
    },

    create: resourceProps => {
        return AjaxService({
            method: 'post',
            url: baseUrl,
            data: resourceProps
        })
        .then(response => response.data)
        .catch(handleServerError);
    },

    update: (resourceId, resourceProps) => {
        return AjaxService({
            method: 'put',
            url: `${baseUrl}/${resourceId}`,
            data: resourceProps
        })
        .then(response => response.data)
        .catch(handleServerError);
    },

    remove: resourceId => {
        return AjaxService({
            method: 'delete',
            url: `${baseUrl}/${resourceId}`
        })
        .then(response => response.data)
        .catch(handleServerError);
    }
});
